import Vue from 'vue'
import { UPLOAD_LIMIT_SIZE, UPLOAD_ADD_INFO_LIMIT_SIZE } from './config'

Object.defineProperties(Vue.prototype, {
  $uploadLimitSize: {
    get() {
      return UPLOAD_LIMIT_SIZE
    }
  },
  $uploadAddInfoLimitSize: {    // 补充信息上传大小限制
    get() {
      return UPLOAD_ADD_INFO_LIMIT_SIZE
    }
  }
})

declare module 'vue/types/vue' {
  interface Vue {
    $uploadLimitSize: number;
    $uploadAddInfoLimitSize: number;
  }
}
